"use client";

import { Box } from "@mantine/core";
import { useEffect, useRef } from "react";

export default function InfiniteLogoBanner() {
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    const scroll = () => {
      if (scrollContainer.scrollLeft >= scrollContainer.scrollWidth / 2) {
        scrollContainer.scrollLeft = 0;
      } else {
        scrollContainer.scrollLeft += 1;
      }
    };

    const intervalId = setInterval(scroll, 30);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <Box
      style={{
        position: "relative",
        width: "100%",
        maxWidth: "100%",
        background: "white",
      }}
    >
      {/* Left fade overlay */}
      <Box
        style={{
          position: "absolute",
          left: 0,
          top: 0,
          bottom: 0,
          width: "45%",
          background: "linear-gradient(to right, white, transparent)",
          pointerEvents: "none",
          zIndex: 1,
        }}
      />
      {/* Right fade overlay */}
      <Box
        style={{
          position: "absolute",
          right: 0,
          top: 0,
          bottom: 0,
          width: "45%",
          background: "linear-gradient(to left, white, transparent)",
          pointerEvents: "none",
          zIndex: 1,
        }}
      />
      <Box
        ref={scrollRef}
        style={{
          display: "flex",
          overflow: "hidden",
          width: "100%",
        }}
      >
        <Box style={{ display: "flex", minWidth: "max-content" }}>
          {/* Original image */}
          <img
            src="/scrollProofNew.webp"
            alt="Style inspiration logos"
            style={{ height: "40px", objectFit: "contain", filter: "grayscale(100%)" }}
          />
          {/* Duplicate for seamless scrolling */}
          <img
            src="/scrollProofNew.webp"
            alt="Style inspiration logos"
            style={{ height: "40px", objectFit: "contain", filter: "grayscale(100%)" }}
          />
        </Box>
      </Box>
    </Box>
  );
}
